import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';


const BranchEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();

    const { isAuthenticated, companyId, userId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, userId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        BranchCode: '',
        ContactNumber1: '',
        Email: '',
        GSTNumber: '',
        CINNumber: '',
        AddressLine1: '',
    });



    useEffect(() => {
        fetchData('BranchApi', `/BranchDetails/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Branch Details:', error);
            });
    }, []);


    const handleChange = event => {
        const { name, value } = event.target;
        console.log(name, value); // Add this line to debug
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: 1,
        }));

        updateData('BranchApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/branchIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;


    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Branch - Edit</h5>
                    <Button

                        style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                        onClick={handleSubmit}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> UPDATE
                    </Button>

                    <Button

                        component={Link}
                        to="/branchIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>
                {/* Render fetched data */}
                <div className="w-full mb-4 flex">
                    <div className="w-4/5 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Branch Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder="Enter Company name"
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/5 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                            Branch Code
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='BranchCode' value={formData.BranchCode} onChange={handleChange} type="text" placeholder="Enter Company Code" readOnly />
                    </div>

                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>


                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                            Contact Number 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber1' value={formData.ContactNumber1} onChange={handleChange} type="text" placeholder="Enter Contact Number 1"
                            required
                            maxLength={15}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber2">
                            Contact Number 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber2' value={formData.ContactNumber2} onChange={handleChange} type="text" placeholder="Enter Contact Number 2"
                            required
                            maxLength={15}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber3">
                            Contact Number 3
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber3' value={formData.ContactNumber3} onChange={handleChange} type="text" placeholder="Enter Contact Number 3"
                            required
                            maxLength={15}
                        />
                    </div>


                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder="Enter Email"
                            maxLength={40}
                            pattern={emailPattern.source}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            GST Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='GSTNumber' value={formData.GSTNumber} onChange={handleChange} type="text" maxLength={15} placeholder="Enter GST Number" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="PanNumber">
                            PAN Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PanNumber' value={formData.PanNumber} onChange={handleChange} type="text" maxLength={15} placeholder="Enter Pan Number" />
                    </div>

                </div>



                <div className="w-full mb-4 flex">
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Address Line 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine1' value={formData.AddressLine1} onChange={handleChange} type="text" placeholder="Enter Address Line 1"
                            maxLength={100}
                            required
                        />
                    </div>

                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Address Line 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine2' value={formData.AddressLine2} onChange={handleChange} type="text" placeholder="Enter Address Line 2"
                            maxLength={100}
                        />
                    </div>

                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-3/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Location">
                            Location
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Location' value={formData.Location} onChange={handleChange} type="text" placeholder="Enter Location"
                            required
                            maxLength={100}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="PinCode">
                            Pin Code
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PinCode' value={formData.PinCode} onChange={handleChange} type="text" placeholder="Enter PinCode"
                            required
                            maxLength={7}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="CashOpening">
                            Cash Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='CashOpening' value={formData.CashOpening} onChange={handleChange} type="number" placeholder="Enter Cash Opening" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="StockOpening">
                            Stock Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='StockOpening' value={formData.StockOpening} onChange={handleChange} type="number" placeholder="Enter Stock Opening" />
                    </div>                    

                </div>

                <div className="w-full mb-4 flex">                    

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="PaymentUPIId">
                            Payment UPI Id
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PaymentUPIId' value={formData.PaymentUPIId} onChange={handleChange} type="text" placeholder="Enter Payment UPI Id"
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="PaymentUPIId">
                            Payment UPI Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PaymentUPIName' value={formData.PaymentUPIName} onChange={handleChange} type="text" placeholder="Enter Payment UPI Name"
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            BToB Prefix
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='BToBPrefix' value={formData.BToBPrefix} onChange={handleChange} type="text" maxLength={10} placeholder="Enter BToB Prefix" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            BToC Prefix
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='BToCPrefix' value={formData.BToCPrefix} onChange={handleChange} type="text" maxLength={10} placeholder="Enter BToC Prefix" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            IGST Prefix
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='IGSTPrefix' value={formData.IGSTPrefix} onChange={handleChange} type="text" maxLength={10} placeholder="Enter IGST Prefix" />
                    </div>


                </div>

            </form>
        </div>

    );
};

export default BranchEdit;
